import { t, useI18n } from "@bookingcom/lingojs-react";
import { localizationUtils } from "@flights/web-api-utils-universal";
const useRyanairHungaryInfoController = (flight) => {
    const i18n = useI18n();
    return {
        header: i18n.trans(t("flights_ryanair_hungary_fd_kbyg_hed")),
        ryanairHungarytext: flight?.segments && localizationUtils.isHungaryDepartingRyanAirFlight(flight?.segments)
            ? i18n.trans(t("flights_ryanair_hungary_fd_kbyg"))
            : undefined
    };
};
export default useRyanairHungaryInfoController;
